let popupWindow = null;

export function openPopup(url, name, options) {
  if (!popupWindow || popupWindow.closed) {
    popupWindow = window.open(url, name, options);
    let popupReady;

    // Check if popup opened successfully (might be blocked by popup blocker)
    if (popupWindow) {
      try {
        // Set up a load handler to mark when popup is fully loaded
        popupWindow.addEventListener('load', function () {
          console.log('[MCP Session Check] Popup fully loaded');
          popupReady = true;
        });

        // Add event listener to detect when popup is closed
        popupWindow.addEventListener('unload', function () {
          // Only process unload events after popup is fully loaded
          if (!popupReady) {
            return;
          }

          console.log(
            '[MCP Session Check] Popup unload event detected',
          );

          // Small timeout to distinguish between navigation and actual closure
          setTimeout(() => {
            if (!popupWindow || popupWindow.closed) {
              console.log('[MCP Session Check] Popup was closed');
              popupWindow = null;
              popupReady = false;

              // Dispatch an event that other components can listen for
              window.dispatchEvent(new CustomEvent('popupClosed'));
            }
          }, 300);
        });
      } catch (e) {
        // Handle potential cross-origin errors
        console.warn(
          '[MCP Session Check] Could not attach event listener',
        );

        // Fallback: Start a periodic check for popup state
        const checkInterval = setInterval(() => {
          if (!popupWindow || popupWindow.closed) {
            console.log(
              '[MCP Session Check] Popup was closed (detected by interval)',
            );
            clearInterval(checkInterval);
            popupWindow = null;
            window.dispatchEvent(new CustomEvent('popupClosed'));
          }
        }, 1000);
      }
    }
  }

  return popupWindow;
}

export function closePopup() {
  if (popupWindow) {
    popupWindow.close();
    popupWindow = null;
    return true;
  }
  return false;
}
